var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('AppMenu',{attrs:{"menu-items":_vm.menuItems}}),_c('AppBar',{attrs:{"menu-items":_vm.menuItems}}),_c('VMain',{attrs:{"data-with-banner":_vm.withBanner}},[_vm._t("default")],2),_c('UFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }